import React from 'react';
import { CartCheckoutSteps } from '@apps/registry/common/components/ShoppingCart';
import { ShoppingCartTelemetryProvider } from '@apps/registry/common/components/ShoppingCart/ShoppingCart.telemetry';
import { ShoppingCartProvider } from '@apps/registry/common/components/ShoppingCart/state';
import type { ShippingAddressFragment } from '@graphql/fragments/shippingAddress.graphql.generated';
import { getGiftWrapThemeListByEventType } from '@shared/components/GiftWrap';
import { useFeatureValue } from '@shared/core/featureFlags';
import { StripeElements, stripeLazySetupOptions } from '@shared/core/stripe';
import { useEventInfo } from '@shared/utils/eventInfo';

type GuestShoppingProviderProps = {
  coupleAddress?: Maybe<ShippingAddressFragment>;
  eventHandle: string;
  eventId?: string;
};

export const GuestShoppingProvider: React.FC<GuestShoppingProviderProps> = ({ eventHandle, children, coupleAddress, eventId }) => {
  const { eventInfo } = useEventInfo();
  const themes = getGiftWrapThemeListByEventType(eventInfo?.eventType);
  const eventTypeHasThemes = themes && themes.length > 0;
  const { value: giftWrapOn } = useFeatureValue('registryGiftWrapExperimentEnabled');
  const registryGiftWrapExperimentEnabled = giftWrapOn === 'on';
  const isGiftWrapEnabled = registryGiftWrapExperimentEnabled && eventTypeHasThemes;

  const checkoutStepsFlow = [
    CartCheckoutSteps.Cart,
    CartCheckoutSteps.Shipping,
    CartCheckoutSteps.Details,
    ...(isGiftWrapEnabled ? [CartCheckoutSteps.Message] : []),
    CartCheckoutSteps.Payment,
  ];
  return (
    <StripeElements options={stripeLazySetupOptions}>
      <ShoppingCartProvider
        coupleAddress={coupleAddress}
        eventHandle={eventHandle}
        eventId={eventId}
        checkoutStepsFlow={checkoutStepsFlow}
        expressCheckoutEnabled={true}
      >
        <ShoppingCartTelemetryProvider context={{ eventId }}>{children}</ShoppingCartTelemetryProvider>
      </ShoppingCartProvider>
    </StripeElements>
  );
};
